function reorderWithSingleUpdate<T extends { posicao: number }>(
  items: T[],
  fromIndex: number,
  toIndex: number,
): T[] {
  const movedItem = { ...items[fromIndex] }
  const updatedItems = items.map((item, index) => {
    if (index === fromIndex) return item

    if (fromIndex < toIndex) {
      if (index > fromIndex && index <= toIndex) {
        return { ...item, posicao: item.posicao - 1 }
      }
    } else if (fromIndex > toIndex) {
      if (index >= toIndex && index < fromIndex) {
        return { ...item, posicao: item.posicao + 1 }
      }
    }

    return item
  })

  movedItem.posicao = toIndex

  const result = [...updatedItems]
  result.splice(fromIndex, 1)
  result.splice(toIndex, 0, movedItem)

  return result
}

export { reorderWithSingleUpdate }
